import React, { useState } from 'react';

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Menu, Home, AlertTriangle, FileText, Settings, 
  ClipboardCheck, History, Upload, FolderOpen,LogOut, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const AppLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const { user, logout } = useAuth();
  const [expandedMenus, setExpandedMenus] = useState({});
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { 
      icon: Home, 
      label: 'Dashboard', 
      id: 'dashboard',
      route: 'dashboard'
    },
    { 
      icon: AlertTriangle, 
      label: 'Risks', 
      id: 'risks',
      subItems: [
        { label: 'View Risks', id: 'risks-view', route: '/risks' },
        { label: 'Add Risk', id: 'risks-new',  route: '/risks/new' },
        { label: 'Categories', id: 'risks-categories',  route: '/risks/categories' }
      ]
    },
    {
      icon: ClipboardCheck,
      label: 'Governance & Approvals',
      id: 'governance',
      subItems: [
        { label: 'SMT Dashboard', id: 'approvals/smt', route: '/approvals/smt'  },
        { label: 'GB Dashboard', id: 'approvals/gb', route: '/approvals/gb' },
        { label: 'Approval History', id: 'governance/history', route: '/governance/history' },
        { label: 'Meeting Schedule', id: 'governance/schedule', route: '/governance/schedule' }
      ]
    },
    {
      icon: History,
      label: 'Audit Trail',
      id: 'audit',
       route: '/reports/audit'
      
    },
    {
      icon: FolderOpen,
      label: 'Documents',
      id: 'documents',
      subItems: [
        { label: 'View Documents', id: 'documents/view', route: '/documents/view'  },
        { label: 'Upload Document', id: 'documents/upload', route: '/documents/upload' },
        { label: 'Categories', id: 'documents/categories', route: '/documents/categories' }
      ]
    },
    { 
      icon: FileText, 
      label: 'Reports', 
      id: 'reports',
      subItems: [
        { label: 'Analytics Dashboard', id: 'reports/analytics', route: '/reports/analytics' },
        /*{ label: 'Custom Reports', id: 'reports/custom', route: '/reports/custom' },
        { label: 'Risk Reports', id: 'reports/risks', route: '/reports/risks' }*/
      ]
    },
    
    /*{
      icon: Upload,
      label: 'System Integration',
      id: 'integration',
      subItems: [
        { label: 'Import/Export', id: 'settings/integration' },
        { label: 'API Management', id: 'settings/api' }
      ]
    },*/
  
  ];

  if(user.id == 1 || user.id == 13 || user.id == 14){
    menuItems.push(
      { 
        icon: Settings, 
        label: 'User Management', 
        id: 'settings/users', route:'/settings/users'    
      }
    );
  }


  const toggleSubMenu = (menuId) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const handleNavigation = (route) => {
    navigate(route);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-md">
        <div className="mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <button
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                className="p-2 rounded-md text-gray-600 hover:text-gray-900"
              >
                <Menu className="h-6 w-6" />
              </button>
              <span className="ml-4 font-semibold text-lg">
                Summit Qualifications Risk Register
              </span>
            </div>
            
            {/* User Menu */}
            <div className="flex items-center space-x-4">
              <div className="text-sm text-gray-600">
                <User className="w-4 h-4 inline mr-2" />
                {user?.full_name}
              </div>
              <button
                onClick={logout}
                className="p-2 rounded-md text-gray-600 hover:text-gray-900 flex items-center"
              >
                <LogOut className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className={`${isSidebarOpen ? 'w-64' : 'w-20'} bg-white shadow-lg transition-all duration-300`}>
          <nav className="mt-5 px-2">
            {menuItems.map((item) => (
              <div key={item.id}>
                <button
                  onClick={() => item.subItems ? toggleSubMenu(item.id) : handleNavigation(item.route)}
                  className="w-full flex items-center px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
                >
                  <item.icon className="h-5 w-5" />
                  {isSidebarOpen && (
                    <>
                      <span className="ml-3">{item.label}</span>
                      {item.subItems && (
                        <span className="ml-auto">
                          {expandedMenus[item.id] ? '−' : '+'}
                        </span>
                      )}
                    </>
                  )}
                </button>
                {isSidebarOpen && item.subItems && expandedMenus[item.id] && (
                  <div className="ml-6 mt-2">
                    {item.subItems.map((subItem) => (
                      <button
                        key={subItem.id}
                        onClick={() => handleNavigation(subItem.route)}
                        className={`w-full text-left px-4 py-2 text-sm rounded-md ${
                          location.pathname === subItem.route
                            ? 'bg-blue-50 text-blue-700'
                            : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                        }`}
                      >
                        {subItem.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-6">
          <div className="container mx-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
